<app-content>
  <app-breadcrumbs>
    <li>
      Ustawienia
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      Ustawienia
    </h2>
    <app-alert-container></app-alert-container>
    @if (!loading() && !pending()) {
      <form autocomplete="off" novalidate [formGroup]="form()" (ngSubmit)="onSubmit()">
        <app-notification-form [form]="form()">
        </app-notification-form>
        @if (form().disabled) {
          <div class="form-actions">
            <a routerLink="../" class="btn btn-secondary">
              Powrót
            </a>
            <button class="btn btn-primary" (click)="form().enable()" type="button">Edytuj</button>
          </div>
        } @else {
          <div class="form-actions">
            <button (click)="this.form().disable()" type="button" class="btn btn-secondary">
              Anuluj
            </button>
            <button class="btn btn-primary" type="submit">Zapisz</button>
          </div>
        }
      </form>
    } @else {
      <app-spinner>
        {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
      </app-spinner>
    }
  </section>
</app-content>
